notifications-header
  li.header-notification
    .dropdown-primary.dropdown
      .dropdown-toggle(data-toggle="dropdown")
        i.feather.icon-bell
        span.notification-count.badge.bg-c-red(if="{opts.count > 0}") {opts.count}
      ul.show-notification.notification-view.dropdown-menu(data-dropdown-in="fadeIn" data-dropdown-out="fadeOut") 
        li
          a(href="/notifications")
            h6 Notifications
            label.label.label-danger New
        li(each="{id in opts.items}")
          notifications-item(tag-scope="notification_{id}")
  script(type="typescript").
    this.mixin('notifications.header');
  style(scoped).
    .feather {
      width: 40px;
      height: 40px;
      font-size: 16px;
      padding: 12px 13px;
      border-radius: 50%;
      text-align: center;
      color: #fff;
      margin-right: 10px;
    }
    a {
      padding: 0 !important;
      display: flex !important;
    }
    a:hover {
      background: none !important;
    }
    h6 {
      margin-left: 50px;
    }
    .notification-msg {
      position: relative;
      height: 1rem;
      width: 100%;
      overflow: hidden;
    }
    ul.notification-view li {
      transition: none !important;
      padding: 0 !important;
    }
    ul.notification-view a {
      padding: 10px 20px !important;
    }
    ul.notification-view li:first-child a {
      display: block;
      position: relative;
    }
    ul.notification-view li:first-child a label{
      right: 0;
      position: absolute;
      top: -1px;
    }
    
    ul.notification-view li:first-child h6{
      margin-left: 0;
    }
    ul.notification-view li .notification-msg:after {
      display: block;
      content: '';
      width: 3rem;
      height: 1rem;
      position: absolute;
      right: 5px;
      top: 0;
      background: -moz-linear-gradient(left, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%); /* FF3.6-15 */
      background: -webkit-linear-gradient(left, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=1 ); /* IE6-9 */
    }
    ul.notification-view li:hover .notification-msg:after {
      background: -moz-linear-gradient(left, rgba(241,241,241,0) 0%, rgba(241,241,241,1) 100%); /* FF3.6-15 */
      background: -webkit-linear-gradient(left, rgba(241,241,241,0) 0%,rgba(241,241,241,1) 100%); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(to right, rgba(241,241,241,0) 0%,rgba(241,241,241,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00f1f1f1', endColorstr='#f1f1f1',GradientType=1 ); /* IE6-9 */
    }
    .media-body.unread:after {
      content: '';
      display: block;
      position: absolute;
      right: 20px;
      top: 22px;
      background: #ff5252;
      width: 5px;
      height: 5px;
      border-radius: 50%;
    }
    .notification-msg {
      margin: 0;
    }
    .notification-title {
      font-size: 15px;
      font-weight: 500;
      margin-bottom: 5px;
    }
    .notification-time {
      font-size: 12px;
      color: #919aa3;
    }
    .notification-count {
      right: 2px !important;
    }
    
    
